import { avatarDefault, imgUser } from '@/assets/images';

import type { GuardianLessonCarouselItem } from './types';

export const MOCK_GUARDIAN_LESSON_CAROUSEL_ITEMS: GuardianLessonCarouselItem[] = [
  {
    id: 'church-lesson-summer-camp',
    label: "Church's lesson",
    date: 'Tue · May, 14',
    time: '16:30',
    academyName: 'Longleaf Academy',
    programName: 'Summer Camp Kids',
    coachName: 'John Wainwright',
    coachAvatar: imgUser,
  },
  {
    id: 'avery-short-game',
    label: "Avery's lesson",
    date: 'Wed · May, 15',
    time: '09:00',
    academyName: 'Pinehurst Academy',
    programName: 'Short Game Skills',
    coachName: 'Sarah Coleman',
    coachAvatar: avatarDefault,
  },
  {
    id: 'miles-pathway',
    label: "Miles's lesson",
    date: 'Fri · May, 17',
    time: '14:15',
    academyName: 'Oak Valley Golf',
    programName: 'Pathway Level 2',
    coachName: 'David Nguyen',
    coachAvatar: imgUser,
  },
];
